import { render } from "./DeviceGroupSettingsModal.vue?vue&type=template&id=2a454f38"
import script from "./DeviceGroupSettingsModal.vue?vue&type=script&lang=js"
export * from "./DeviceGroupSettingsModal.vue?vue&type=script&lang=js"
script.render = render

export default script